import { Component, OnInit } from "@angular/core";
import { MessagingService } from "../../../services/messaging.service";
import { AuthService } from "../../../core/auth.service";
import { Message } from "../../../models/message";
import { Observable } from "rxjs/Observable";
import {
  AngularFirestore,
  AngularFirestoreCollection
} from "angularfire2/firestore";

@Component({
  selector: "app-message-list",
  templateUrl: "./message-list.component.html",
  styleUrls: ["./message-list.component.css"]
})
export class MessageListComponent implements OnInit {
  myUser;

  messageCollection: AngularFirestoreCollection<Message>;
  messages: Observable<Message[]>;

  archivCollection: AngularFirestoreCollection<Message>;
  archiveMsgs: Observable<Message[]>;

  markReadOpacity = "1";
  replyActive: boolean = false;
  archivedMessage: boolean;

  archivActive: boolean = false;
  replyMId = "";

  reMessage: Message = {
    sendFrom: {},
    sendTo: "",
    title: "",
    body: ""
  };

  constructor(
    private messagingService: MessagingService,
    public auth: AuthService,
    private afs: AngularFirestore
  ) {
    this.myUser = this.auth.getUserObject();
    console.log("logged in User", this.myUser);
  }

  ngOnInit() {
    this.messageCollection = this.afs.collection("messages", ref => {
      return ref
        .where("sendTo", "==", this.myUser.userId)
        .where("archived", "==", false)
        .orderBy("createdAt", "desc");
    });
    this.messages = this.messageCollection.valueChanges();

    this.messages.subscribe(ref => {
      console.log(ref.length);
    })
    

    this.archivCollection = this.afs.collection("messages", ref => {
      return ref
        .where("sendTo", "==", this.myUser.userId)
        .where("archived", "==", true)
        .orderBy("createdAt", "desc");
    });
    this.archiveMsgs = this.archivCollection.valueChanges();
    console.log(this.archiveMsgs);
  }

  markRead(messageId, b) {
    console.log("mark read implementieren", messageId);
    if (b === false) {
      this.markReadOpacity = "0.5";
    } else {
      this.markReadOpacity = "1";
    }
    this.messagingService.markRead(messageId, b);
  }

  replyActiveM(uid, mid) {
    this.replyActive = !this.replyActive;
    this.archivActive = false;
    console.log(this.replyActive);
    this.reMessage.sendTo = uid;
    //this.reMessage.
    this.replyMId = mid;
  }

  replyMessage(reply) {
    console.log(this.myUser);
    console.log(reply);
    this.reMessage.sendFrom = this.myUser;
    console.log("Reply Message", this.reMessage);

    this.messagingService.sendMessage(this.reMessage);
    this.replyActive = false;

    this.archiveMessage(this.replyMId, true);
  }

  archiveMessage(mId, b) {
    this.archivedMessage = b;
    this.messagingService.archiveMessage(mId, b);
  }

  showArchive() {
    this.archivActive = !this.archivActive;
  }

  deleteMessage(messageId) {
    this.messagingService.deleteMessage(messageId);
  }
}



// WEBPACK FOOTER //
// /Users/akirchhoff/Documents/Development/loveyourcamper-app/src/app/components/messaging/message-list/message-list.component.ts